/**
 * Color Configuration
 *
 * Centralized color constants for consistent theming across the application.
 * Mirrored from the main website for visual consistency.
 */

export const THEME_COLORS = {
  // Highlight colors for important text
  HIGHLIGHT: '#fbbf24', // amber-400 - primary highlight color
  HIGHLIGHT_SECONDARY: '#f59e0b', // amber-500 - secondary highlight

  // Navigation color for in-article navigation links
  NAVIGATION: '#3b82f6', // blue-500 (lighter)

  // Brand colors
  PRIMARY: '#8b5cf6', // violet-500
  SECONDARY: '#a855f7', // purple-500

  // Text colors
  TEXT_PRIMARY: '#ffffff',
  TEXT_SECONDARY: '#d1d5db', // gray-300
  TEXT_MUTED: '#9ca3af', // gray-400

  // Background colors
  BG_GRADIENT_FROM: '#111827', // gray-900
  BG_GRADIENT_VIA: '#581c87', // purple-900
  BG_GRADIENT_TO: '#5b21b6' // violet-900
};

export const getHighlightColor = () => THEME_COLORS.HIGHLIGHT;
export const getNavigationColor = () => THEME_COLORS.NAVIGATION;

// Gradient text used by Innovation headings on the main website
export const getInnovationTextClasses = () =>
  'text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400';

export const standardizeHighlightColors = (content) => {
  if (!content || typeof content !== 'string') return content;
  return content.replace(
    /color:\s*#[a-fA-F0-9]{6}|color:\s*#[a-fA-F0-9]{3}|color:\s*red|color:\s*purple|color:\s*violet/g,
    `color: ${THEME_COLORS.HIGHLIGHT}`
  );
};

export default THEME_COLORS;


